import React, { Component } from 'react';
import moment from 'moment';

class DeviceRegister extends Component {
    constructor(props) {
        super(props);

        this.allDevices = window.devices;

        const manufacturers = this.populateDropdown(this.allDevices, 'display_device_manufacturer');
        const models = this.populateDropdown(this.allDevices, 'display_device_model', true);
        const versions = this.populateDropdown(this.allDevices, 'display_pci_standard_name_and_version', true);

        this.initialState = {
            tableList: this.allDevices,
            manufacturers,
            models,
            versions,
            selectedManufacturer: false,
            selectedModel: false,
            selectedVersion: false,
            filtered: false,
            toggledDevices: [],
        };

        this.style = {
            showExtra: {
                display: 'block',
            },
            hideExtra: {
                display: 'none',
            },
            noMarginTop: {
                marginTop: 0,
            },
        };

        this.state = this.initialState;

        this.manufacturerChange = this.manufacturerChange.bind(this);
        this.modelChange = this.modelChange.bind(this);
        this.versionChange = this.versionChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.toggleDeviceVersions = this.toggleDeviceVersions.bind(this);
    }

    populateDropdown(devices, lookup, sort = false) {
        const addedDropdownList = [];

        const dropdownList = devices.filter((device, i) => {
            if (!addedDropdownList.includes(device[lookup])) {
                addedDropdownList.push(device[lookup]);
                return true;
            }

            return false;
        });

        if (sort) {
            return dropdownList.sort((a, b) => {
                if (a[lookup] && b[lookup]) {
                    a = a[lookup].toUpperCase();
                    b = b[lookup].toUpperCase();

                    if (a < b) {
                        return -1;
                    }
                    if (a > b) {
                        return 1;
                    }
                }

                return 0;
            });
        }
        return dropdownList;
    }

    handleChange(manufacturer, model, version) {
        const deviceList = this.allDevices.filter((device, i) => {
            if (manufacturer && manufacturer !== device.display_device_manufacturer.toLowerCase()) {
                return false;
            }
            if (model && model !== device.display_device_model.toLowerCase()) {
                return false;
            }

            if (version && version !== device.display_pci_standard_name_and_version.toLowerCase()) {
                return false;
            }

            return true;
        });

        const manufacturers = this.populateDropdown(deviceList, 'display_device_manufacturer');
        const models = this.populateDropdown(deviceList, 'display_device_model', true);
        const versions = this.populateDropdown(deviceList, 'display_pci_standard_name_and_version', true);

        this.setState({
            tableList: deviceList,
            manufacturers,
            models,
            versions,
            selectedManufacturer: manufacturer,
            selectedModel: model,
            selectedVersion: version,
            filtered: true,

        });
    }

    manufacturerChange(e) {
        const { selectedModel, selectedVersion } = this.state;

        const { target } = e;

        const selectedManufacturer = target.options[target.selectedIndex].value;

        this.handleChange(selectedManufacturer, selectedModel, selectedVersion);

    }

    modelChange(e) {
        const { selectedManufacturer, selectedVersion } = this.state;

        const { target } = e;

        const selectedModel = target.options[target.selectedIndex].value;

        this.handleChange(selectedManufacturer, selectedModel, selectedVersion);
    }

    versionChange(e) {
        const { selectedModel, selectedManufacturer } = this.state;

        const { target } = e;

        const selectedVersion = target.options[target.selectedIndex].value;

        this.handleChange(selectedManufacturer, selectedModel, selectedVersion);
    }

    clearSearch(e) {
        e.preventDefault();
        this.setState(this.initialState);
    }

    toggleDeviceVersions(deviceId, e) {
        e.preventDefault();

        const { toggledDevices } = this.state;

        let updatedToggledDevices = toggledDevices;

        if (toggledDevices.includes(deviceId)) {
            updatedToggledDevices = updatedToggledDevices.filter(item => item !== deviceId);
        } else {
            updatedToggledDevices.push(deviceId);
        }

        this.setState({
            toggledDevices: updatedToggledDevices,
        });

    }

    render() {
        const { tableList, manufacturers, models, versions, filtered, selectedManufacturer,
            selectedModel, selectedVersion, toggledDevices } = this.state;

        return (
            <div>
                <div className="border-top-bottom full-bleed--white border-left">
                    <div className="wrapper wrapper--large">
                        <form className="form-label form-css-label">
                            <ul className="list-inline tab-nav select-list u-mb--xsmall">
                                <li className="tab-nav__item list-inline__item">
                                    <fieldset className="fieldset">
                                        <div className="select-style">
                                            <select name="manufacturer" onChange={ this.manufacturerChange } value={ selectedManufacturer || '' }>
                                                { !filtered || manufacturers.length > 1 ? (
                                                    <option value="">Manufacturer</option>
                                                ) : null}
                                                { manufacturers.map((manufacturer, i) => (
                                                    <option key={ i } value={ manufacturer.display_device_manufacturer.toLowerCase() }>{manufacturer.display_device_manufacturer}</option>
                                                ))}
                                            </select>
                                            <svg className="select-icon icon-dropdown" style={{ width: '13px', height: '9px' }}>
                                                <use xlinkHref="#icon-dropdown" />
                                            </svg>
                                        </div>
                                    </fieldset>
                                </li>
                                <li className="tab-nav__item list-inline__item">
                                    <fieldset className="fieldset">
                                        <div className="select-style">
                                            <select name="model" onChange={ this.modelChange } value={ selectedModel || '' }>
                                                { !filtered || models.length > 1 ? (
                                                    <option value="">Model</option>
                                                ) : null}
                                                { models.map((manufacturer, i) => (
                                                    <option key={ i } value={ manufacturer.display_device_model.toLowerCase() }>{manufacturer.display_device_model}</option>
                                                ))}
                                            </select>
                                            <svg className="select-icon icon-dropdown" style={{ width: '13px', height: '9px' }}>
                                                <use xlinkHref="#icon-dropdown" />
                                            </svg>
                                        </div>
                                    </fieldset>
                                </li>
                                <li className="tab-nav__item list-inline__item">
                                    <fieldset className="fieldset">
                                        <div className="select-style">
                                            <select name="version" onChange={ this.versionChange } value={ selectedVersion || '' }>
                                                { !filtered || versions.length > 1 ? (
                                                    <option value="">Version</option>
                                                ) : null}
                                                { versions.map((manufacturer, i) => (
                                                    <option key={ i } value={ manufacturer.display_pci_standard_name_and_version.toLowerCase() }>{manufacturer.display_pci_standard_name_and_version}</option>
                                                ))}
                                            </select>
                                            <svg className="select-icon icon-dropdown" style={{ width: '13px', height: '9px' }}>
                                                <use xlinkHref="#icon-dropdown" />
                                            </svg>
                                        </div>
                                    </fieldset>
                                </li>
                                { filtered ? (
                                    <li
                                        className="tab-nav__item list-inline__item"
                                    >
                                        <a onClick={ this.clearSearch }>
                                            <svg className="icon-close-device">
                                                <use xlinkHref="#icon-close" />
                                            </svg>
                                        </a>
                                    </li>
                                ) : null }

                            </ul>
                        </form>
                    </div>
                </div>

                <div className="wrapper wrapper--large table overflow--auto">
                    <div className="pd-right">
                        <table className="table u-mt--xsmall u-mb--xsmall table--striped">
                            <thead>
                                <tr>
                                    <th className="sticky-col" width="25%">Manufacturer &amp; Model</th>
                                    <th width="15%">PCI Approval Number</th>
                                    <th width="20%">Approval Version/Class</th>
                                    <th width="20%">Payments NZ Date of No New Connection</th>
                                    <th width="20%">Payments NZ Sunset Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                { tableList.map((device, i) => (
                                    <tr key={ i }>
                                        <td>
                                            <strong>{ device.display_device_manufacturer }</strong>
                                            { device.display_device_model ? (
                                                <span><br />{ device.display_device_model }</span>
                                            ) : null }
                                            { device.display_device_hardware_version ? (
                                                <span className="xsmall"><br />Hardware: { device.display_device_hardware_version }</span>
                                            ) : null }
                                            { device.display_application_version || device.display_device_firmware_version ? (
                                                <div>
                                                    <div style={ toggledDevices.includes(device.id) ? this.style.showExtra : this.style.hideExtra }>
                                                        { device.display_device_firmware_version ? (
                                                            <span className="xsmall">Firmware: { device.display_device_firmware_version }</span>
                                                        ) : null }
                                                        { device.display_application_version ? (
                                                            <span className="xsmall">
                                                                {device.display_device_firmware_version ? (<br />) : null }
                                                                Application: { device.display_application_version }
                                                            </span>
                                                        ) : null }
                                                    </div>
                                                    <p className="xsmall" style={ this.style.noMarginTop }>
                                                        <a href="#" onClick={ (e) => { this.toggleDeviceVersions(device.id, e); } }>{toggledDevices.includes(device.id) ? 'Show me less' : 'Show me more' }</a>
                                                    </p>
                                                </div>
                                            ) : null}
                                        </td>
                                        <td>
                                            { device.display_pci_approval_number }
                                        </td>
                                        <td>
                                            { device.display_pci_standard_name_and_version }
                                        </td>
                                        <td>
                                            { device.no_new_connection_date_tbd ? 'TBD' : device.no_new_connection_date ? `${ moment(device.no_new_connection_date).format('D MMM Y') }` : 'TBD' }
                                        </td>
                                        <td>
                                            { device.sunset_date_tbd ? 'TBD' : device.sunset_date ? `${ moment(device.sunset_date).format('D MMM Y') }` : 'TBD' }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeviceRegister;
